module.exports = __webpack_public_path__ + "static/purple_dragon_knight-4729cda2456a5e49c97f5b77103cc7f6.png";